import { SavingsContributionBase } from 'app/containers/PipelineSection/Retirement/SavingsContributionBase';
import { personPossessive } from 'app/utils'
import * as React from 'react'

class RetirementSpouseContributions extends SavingsContributionBase {

  componentWillMount() {
    this.setup('spouse')
    this.updateDcTotal()

    this.onAppStateUpdate((appState) => {
      const profile = appState.Profile.getNative('info')
      const personFirstNamePossessive = personPossessive(profile.getSpouse().firstName)

      this.setState({ personFirstNamePossessive, profile })
    })
  }

}

const RetirementSpouseContributionsQuestionsGroup = () => (
  <RetirementSpouseContributions
    header="Contributions" icon="" />
)

export {
  RetirementSpouseContributionsQuestionsGroup
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Retirement/SpouseContributions/index.tsx